class OrderMapper {
  static createModelFromResponse(data) {
    return {
      orderReference: data.order_reference,
      receiptUrl: data.receipt_url,
      totalAmount: data.total_amount,
      shipments: data.shipments.map(data => ({
        insuranceCoverageAmount: data.insurance_coverage_amount,
        shipmentCustomReference: data.shipment_custom_reference,
        shipmentReference: data.shipment_reference,
        status: data.status,
        message: data.message,
        totalPrice: data.total_price
      }))
    };
  }

  /**
   * Returns a JSON with the payload necessary to create a Order.
   *
   */
  static getCreatePayload(_ref) {
    let {
      orderCustomReference,
      payment,
      shipments,
      voucher,
      customsInvoiceId,
      carriersTermsAndConditions
    } = _ref;
    return {
      order_custom_reference: orderCustomReference,
      ...(payment.id && {
        payment_method_id: payment.id
      }),
      ...(payment.method && payment.type && {
        payment_method_data: {
          is_one_time_payment: false,
          payment_method: payment.method,
          payment_type: payment.type,
          ...(payment.nonce && {
            payment_method_nonce: payment.nonce
          }),
          ...(payment.deviceData && {
            payment_device_data: payment.deviceData
          })
        }
      }),
      shipments: shipments.map(shipment => shipment.getCreateOrderPayload(voucher, customsInvoiceId)),
      carriers_terms_and_conditions: carriersTermsAndConditions
    };
  }
}

export { OrderMapper };
//# sourceMappingURL=OrderMapper.js.map
